var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"label":_vm.$t('appointment.formCreate.labels.observations'),"rows":"4","no-resize":"","outlined":""},on:{"input":_vm.handleMeetingObservations}})}
var staticRenderFns = []

export { render, staticRenderFns }